module.exports = __webpack_public_path__ + "static/media/Estate King Bed Base with Drawer Storage - 180x200 cm_White.3211683e.png";